import React, { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { useScreenInit } from '../useScreenInit.js';
import { applyTheme, getInitialTheme, saveTheme, type Theme } from '../utils/theme';
type ThemeContextValue = {
  theme: Theme;
  toggleTheme: () => void;
};
const ThemeContext = createContext<ThemeContextValue | null>(null);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const screenInit = useScreenInit() as {
    theme?: Theme;
  };
  const [theme, setTheme] = useState<Theme>(() => {
    if (screenInit.theme) return screenInit.theme;
    return document.documentElement.classList.contains('dark') ? 'dark' : getInitialTheme();
  });
  useLayoutEffect(() => {
    if (screenInit.theme) applyTheme(screenInit.theme);
  }, [screenInit.theme]);
  const toggleTheme = useCallback(() => {
    setTheme(current => {
      const next: Theme = current === 'dark' ? 'light' : 'dark';
      applyTheme(next, true);
      saveTheme(next);
      return next;
    });
  }, []);
  const value = useMemo(() => ({
    theme,
    toggleTheme
  }), [theme, toggleTheme]);
  return <ThemeContext.Provider value={value} data-id="element-788" data-mp="zhzhpxkmdu">{children}</ThemeContext.Provider>;
}
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}